import React from 'react';
import { Logo } from './Logo';
export function Footer() {
  return <footer className="bg-[#111827] py-12" data-id="element-80">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center" data-id="element-81">
        <a href="#brand" className="mb-6 block hover:opacity-80 transition-opacity" title="Brand Book" data-id="element-82">
          <Logo showText={true} size="md" variant="light" data-id="element-83" />
        </a>
        <p className="text-gray-400 text-sm text-center" data-id="element-84">
          © 2026 InspectIA. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}